import React from "react";

import {BrandFlagIcon} from "@pg-design/icons-module";

import {InfoPanel} from "../../atoms/InfoPanel";

interface IProps {
    className?: string;
    customHeading?: string;
    customSubHeading?: string;
}

export const VendorEmptyList: React.FC<IProps> = (props) => {
    return (
        <InfoPanel
            css={props.className}
            icon={BrandFlagIcon}
            heading={props.customHeading ?? "Nie znaleziono deweloperów o określonych kryteriach."}
            headingAs="h2"
            subHeading={props.customSubHeading ?? "Rozszerz lub zmień parametry szukania i spróbuj ponownie."}
            subHeadingAs="p"
        />
    );
};
import React from "react";

import {BrandFlagIcon} from "@pg-design/icons-module";

import {InfoPanel} from "../../atoms/InfoPanel";

interface IProps {
    className?: string;
    customHeading?: string;
    customSubHeading?: string;
}

export const VendorEmptyList: React.FC<IProps> = (props) => {
    return (
        <InfoPanel
            css={props.className}
            icon={BrandFlagIcon}
            heading={props.customHeading ?? "Nie znaleziono deweloperów o określonych kryteriach."}
            headingAs="h2"
            subHeading={props.customSubHeading ?? "Rozszerz lub zmień parametry szukania i spróbuj ponownie."}
            subHeadingAs="p"
        />
    );
};
